import "./kpiFilterItem.css";
import "../../../manageKPICommon.css";
interface KPIFilterItemProps {
  id: string;
  title: string;
  selected: boolean;
  handleCheckboxChange: (id: string) => void;
}
const KPIFilterItem: React.FC<KPIFilterItemProps> = ({
  id,
  title,
  selected,
  handleCheckboxChange,
}) => {
  function capitalizeSentence(sentence:string) {
  return sentence
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) 
    .join(" "); 
}
  return (
    <>
    <div
      onClick={() => {
        handleCheckboxChange(id)}}
      className="kpi-filter-item gray-border round-border"
    >
      <div className="checkbox-wrapper">
        <input
          id={`checkbox-${id}`} // unique id for each checkbox
          className="kpi-filter-item-checkbox"
          type="checkbox"
          checked={selected}
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
        <label
          htmlFor={`checkbox-${id}`}
          className="custom-checkbox-label"
        ></label>
      </div>

      <div className="kpi-filter-item-info">
        <div className="kpi-filter-item-heading">{capitalizeSentence(title)}</div>
      </div>
    </div>
    </>
  );
};

export default KPIFilterItem;
